import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IonAvatar } from '@ionic/angular/standalone';

import { UserInitialsPipe } from '../../pipes/user-initials.pipe';

@Component({
  selector: 'lib-contact-avatar',
  standalone: true,
  imports: [CommonModule, IonAvatar, UserInitialsPipe],
  templateUrl: './contact-avatar.component.html',
  styleUrls: ['./contact-avatar.component.scss'],
})
export class ContactAvatarComponent {
  // inputs
  alias = input<string>('');
  role = input<string | undefined>(undefined);
  count = input<string | undefined>(undefined);
}
